export default __webpack_public_path__ + "static/media/odinLogo1.221e3406.png";